export const HEADING = 'Product Information';
export const BANNER_ASPECT_RATION = 1.99;
